export default __webpack_public_path__ + "static/media/download-inactive.6bc11f84.svg";